export enum MeetingParticipantSource {
    TeamMember = 2,
    Manual = 1,
    BuyerParticipant = 3,
}
